module.exports = __webpack_public_path__ + "img/trio-page-6-pearls.5c9dd9d2.jpg";